<template>
  <v-footer>
    <v-container>
      <v-row align="center" no-gutters>
        <v-spacer class="hidden-sm-and-down" />
        <v-col class="text-body-1" cols="12" md="auto">
          <small>Copyright (c) 2019 - {{ currentYear }}, Picknote Inc.</small>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    currentYear: new Date().getFullYear()
  })
}
</script>
